/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Sleep_OkInputs */

const en_us2_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okay`)
};

const pt_br2_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const es_419_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const pt_pt2_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const fr_fr2_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct`)
};

const de_de2_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okay`)
};

const it_it2_workout_sleep_ok = /** @type {(inputs: Workout_Sleep_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normale`)
};

/**
* | output |
* | --- |
* | "Okay" |
*
* @param {Workout_Sleep_OkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sleep_ok = /** @type {((inputs?: Workout_Sleep_OkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sleep_OkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sleep_ok(inputs)
	if (locale === "es-419") return es_419_workout_sleep_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sleep_ok(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sleep_ok(inputs)
	if (locale === "de-DE") return de_de2_workout_sleep_ok(inputs)
	if (locale === "it-IT") return it_it2_workout_sleep_ok(inputs)
	return en_us2_workout_sleep_ok(inputs)
});
export { workout_sleep_ok as "workout.sleep_ok" }